$(function () {

  var is_inactive_modal = localStorage.getItem('is_inactive_modal');
  if (is_inactive_modal) {
    is_inactive_modal = JSON.parse(is_inactive_modal.toLowerCase());
  }

  if (is_inactive_modal === null || is_inactive_modal == false) {
    $('.overlay-modal').fadeIn();
    $('.aw-popup-password-reset').fadeIn();
  }

  $('.overlay-modal , .aw-icon-close, .aw-theme-button').on('click', function () {
    $('.overlay-modal').fadeOut();
    $('.aw-popup-password-reset').fadeOut();
  });

  $('.aw-icon-close, .aw-theme-button').on('click', function () {
    $('.overlay-modal').fadeOut();
    $('.aw-popup-password-reset').fadeOut();
    if ($('#is_inactive').prop("checked")) {
      localStorage.setItem('is_inactive_modal', true);
    }
  });
});